import { RouteComponentProps } from "react-router-dom"
import { useTask } from "../../../tasks/hooks/use-task"
import CircularProgress from "@material-ui/core/CircularProgress"
import Board from "../../../boards/components/Board"
import ErrorList from "../../../components/ErrorList"
import { useTranslation } from "react-i18next"
import { useGetBoardV2Query } from "../../../boards/api/v2"

type RouteParams = { taskId: string }

const queryOptions = { refetchOnMountOrArgChange: true } as const

const TaskKanbanRoute = ({ match }: RouteComponentProps<RouteParams>) => {
  const translations = useTranslations()
  const { taskId } = match.params
  const { task, isLoading: isLoadingTask } = useTask(taskId, queryOptions)
  const {
    data: board,
    isLoading: isLoadingBoard,
    isError,
  } = useGetBoardV2Query({ id: taskId, type: "task" }, queryOptions)

  if (isLoadingBoard || isLoadingTask) return <CircularProgress />
  if (isError) return <ErrorList errors={[translations.fetchErrorBoard]} />
  if (!board) return <ErrorList errors={[translations.boardNotFoundError]} />
  if (!task) return <ErrorList errors={[translations.taskNotFoundError]} />

  return <Board board={board} canAddTasks={task.canCreate} canAddTodos={task.canCreateTaskTodos} />
}

const defaultTranslations = {
  fetchErrorBoard: "Failed to fetch board",
  boardNotFoundError: "Board not found",
  taskNotFoundError: "Task not found",
}

const useTranslations = (): typeof defaultTranslations => {
  const { t } = useTranslation("translation")

  return {
    fetchErrorBoard: t("fetchErrorBoard", defaultTranslations.fetchErrorBoard),
    boardNotFoundError: t("boardNotFoundError", defaultTranslations.boardNotFoundError),
    taskNotFoundError: t("taskNotFoundError", defaultTranslations.taskNotFoundError),
  }
}

export default TaskKanbanRoute
